<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container">
      <div class="row">
        <div class="col-sm-12" style="margin:20px; background:white; border-radius:10px;padding:10px">
          <h1> About Us </h1>
          <p>
            Cheer and dance are sensational sports that provide a powerful, positive, and healthy outlet for millions of athletes. It is the undertaking of Everything Cheer and Dance to provide a platform to link all cheer and dance programs to the resources essential for success.
          </p>
          <p>
            Everything Cheer and Dance was created by cheerleaders and dancers, for cheerleaders and dancers. With over 30 years’ experience in the cheer and dance world, we would frequently be asked questions such as "Where do I find good judges," and "How do I find someone to fit my team for uniforms?"  In response to the aforementioned questions, we created Everything Cheer and Dance, a plan to locate everything necessary for your program.
          </p>
          <p>
            Novice, as well as seasoned coaches are always seeking a means to construct a more successful program. It is the objective of the staff at Everything Cheer and Dance to help create an equal playing field when finding the resources required to facilitate a successful program.
          </p>
          <p>
            On the flip side, there are a plethora of phenomenal cheer and dance talents/resources who want to be found. Everything Cheer and Dance is a means by which all pertinent talent can be located.
          </p>
          <p>
            We hope Everything Cheer and Dance proves to be helpful in your search. It is our mission to be used as a megaphone to bring the cheer and dance world closer together.
          </p>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from './nav/NavigationBar'
import Store from './HomeStore'
import API from '@/API/API'
import DashboardFooter from './nav/Footer'
import Utils from '../Utils/Utils'
import Navigator from '@/router/navigator'
import AccountSessionUtils from "@/components/account/AccountSessionUtils";
export default {
  name: 'Home',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      store: Store,
      api: API,
      nav: Navigator,
      accountUtils: AccountSessionUtils
    }
  },
  mounted () {
    this.accountUtils.authorize(
      userId => {
        this.store.state.currentUserId = userId;
      },
      () => {}
    );
  },
  methods: {


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.service-card{
  background: white;
  border-radius: 10px;
  height: 150px;
  overflow:hidden;
}

.orange {
  color:#FF6F5E;
}

.blue {
  color:#192965;
}

.orange-overlay {
  filter: invert(53%) sepia(34%) saturate(887%) hue-rotate(318deg) brightness(98%) contrast(109%);
}

.blue-overlay {
  filter: invert(16%) sepia(14%) saturate(6187%) hue-rotate(205deg) brightness(92%) contrast(100%);
}

p{
  padding-left:10px;
  padding-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue